import { LaskutettavatPalvelut } from '@lemon/core-firebase/model/lasku'

export enum TuoteKategoria {
  HOLVI = 'Holvi',
  KIRJANPITO_KAPPALEHINTA = 'Kirjanpito kappalehinta',
  KIRJANPITO_TUNTITYO = 'Kirjanpito tuntityö',
  MUUT_PALVELUT = 'Muut palvelut',
  PALKAT = 'Palkat',
}

export enum TuoteKategoriaEng {
  HOLVI = 'Holvi',
  KIRJANPITO_KAPPALEHINTA = 'Bookkeeping per item',
  KIRJANPITO_TUNTITYO = 'Bookkeeping hourly work',
  MUUT_PALVELUT = 'Other services',
  PALKAT = 'Payroll',
}

export enum TilastoKategoria {
  KUUKAUSITTAINEN_PALVELUMAKSU = 'Kuukausittainen palvelumaksu',
  JATKUVALUONTEINEN_KERTALASKUTUS = 'Jatkuvaluonteinen kertalaskutus',
  KERTALASKUTUS = 'Kertalaskutus',
  PALKKAPALVELUT = 'Palkkapalvelut',
  HOLVI_ZEN = 'Holvi Zen',
  OHJELMISTO = 'Ohjelmisto',
}

export interface Tuotenimike {
  avain: LaskutettavatPalvelut
  nimi: string
  engNimi: string
  kategoria: TuoteKategoria
  engKategoria: TuoteKategoriaEng
  maara: number
  hinta?: number
  tilastoJarjestys: number
  tilastoKategoria: TilastoKategoria
  muuJatkuvaVeloitus?: boolean
}

export const tuotenimikkeet: readonly Tuotenimike[] = [
  {
    avain: LaskutettavatPalvelut.HOLVI_KIRJANPITO,
    nimi: 'Holvi Zen kuukausittaiset kirjanpidot',
    engNimi: 'Holvi Zen monthly bookkeeping',
    kategoria: TuoteKategoria.HOLVI,
    engKategoria: TuoteKategoriaEng.HOLVI,
    hinta: 44,
    maara: 1,
    tilastoJarjestys: 50,
    tilastoKategoria: TilastoKategoria.HOLVI_ZEN,
  },
  {
    avain: LaskutettavatPalvelut.HOLVI_KORJAUKSET_LASKUTUS,
    nimi: 'Holvi Zen korjaukset laskutukseen',
    engNimi: 'Holvi Zen corrections on billing',
    kategoria: TuoteKategoria.HOLVI,
    engKategoria: TuoteKategoriaEng.HOLVI,
    hinta: 44,
    maara: 1,
    tilastoJarjestys: 51,
    tilastoKategoria: TilastoKategoria.HOLVI_ZEN,
  },
  {
    avain: LaskutettavatPalvelut.HOLVI_TAKAUTUVATYO,
    nimi: 'Holvi Zen takautuvat kirjanpidot',
    engNimi: 'Holvi Zen retroactive bookkeeping',
    kategoria: TuoteKategoria.HOLVI,
    engKategoria: TuoteKategoriaEng.HOLVI,
    hinta: 44,
    maara: 1,
    tilastoJarjestys: 52,
    tilastoKategoria: TilastoKategoria.HOLVI_ZEN,
  },
  {
    avain: LaskutettavatPalvelut.HOLVI_VEROILMOITUS,
    nimi: 'Holvi Zen veroilmoitus',
    engNimi: 'Holvi Zen tax return',
    kategoria: TuoteKategoria.HOLVI,
    engKategoria: TuoteKategoriaEng.HOLVI,
    hinta: 80,
    maara: 1,
    tilastoJarjestys: 53,
    tilastoKategoria: TilastoKategoria.HOLVI_ZEN,
  },
  {
    avain: LaskutettavatPalvelut.AINEISTON_TOIMITTAMINEN_PAATTYNEELLE,
    nimi: 'Aineiston toimittaminen sopimuksen päättymisen jälkeen',
    engNimi: 'Material delivery after contract termination',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 100,
    maara: 1,
    tilastoJarjestys: 18,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.AINEISTON_TOIMITTAMISESTA_MUISTUTTAMINEN,
    nimi: 'Aineiston toimittamisesta muistuttaminen',
    engNimi: 'Material delivery reminder',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 45,
    maara: 1,
    tilastoJarjestys: 19,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.ALOITUSMAKSU,
    nimi: 'Aloitusmaksu',
    engNimi: 'Setup fee',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 100,
    maara: 1,
    tilastoJarjestys: 20,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.ENNAKKOVERO_MUUTOS,
    nimi: 'Ennakkoveron muutos/hakemus',
    engNimi: 'Prepaid tax change/application',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 45,
    maara: 1,
    tilastoJarjestys: 21,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.HOLDING_YHTIO_VUOSIVELOITUS,
    nimi: 'Holding-yhtiö, vuosiveloitus',
    engNimi: 'Holding company, annual charge',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 470,
    maara: 1,
    tilastoJarjestys: 74,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
    muuJatkuvaVeloitus: true,
  },
  {
    avain: LaskutettavatPalvelut.KAPITALISAATIOSOPIMUS_VUOSIVELOITUS,
    nimi: 'Kapitalisaatiosopimus, vuosiveloitus',
    engNimi: 'Capitalization agreement, annual charge',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 690,
    maara: 1,
    tilastoJarjestys: 75,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
    muuJatkuvaVeloitus: true,
  },
  {
    avain: LaskutettavatPalvelut.KIRJANPITO_LISATYO_KAPPALEHINTA,
    nimi: 'Kirjanpidon lisätyö (kappalehinta)',
    engNimi: 'Additional bookkeeping work (per item)',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    maara: 1,
    tilastoJarjestys: 31,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.OSAKASLAINAILMOITUS,
    nimi: 'Osakaslainailmoitus',
    engNimi: 'Shareholder loan notice',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 50,
    maara: 1,
    tilastoJarjestys: 26,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.OY_TILINPAATOS,
    nimi: 'Osakeyhtiön tilinpäätös ja veroilmoitus',
    engNimi: 'Limited company financial statement and tax return',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 300,
    maara: 1,
    tilastoJarjestys: 12,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.POYTAKIRJA,
    nimi: 'Pöytäkirja',
    engNimi: 'Minutes of the meeting',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 70,
    maara: 1,
    tilastoJarjestys: 29,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.AINEISTON_SAILYTYSMAKSU,
    nimi: 'Pöytälaatikkosopimus, vuosiveloitus',
    engNimi: 'Archive storage fee, annual charge',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 290,
    maara: 1,
    tilastoJarjestys: 17,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
    muuJatkuvaVeloitus: true,
  },
  {
    avain: LaskutettavatPalvelut.TULOREKISTERI_ILMOITUS,
    nimi: 'Tulorekisteri-ilmoitus',
    engNimi: 'Income register notice',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 45,
    maara: 1,
    tilastoJarjestys: 22,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.TILINPAATOS_REKISTEROINTI_PRH,
    nimi: 'Tilinpäätöksen rekisteröinti PRH:lle',
    engNimi: 'Financial statement registration to PRH',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 100,
    maara: 1,
    tilastoJarjestys: 14,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.TMI_TILINPAATOS,
    nimi: 'Toiminimen tilinpäätös',
    engNimi: "Private trader's financial statement",
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 200,
    maara: 1,
    tilastoJarjestys: 13,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.VELKAKIRJA,
    nimi: 'Velkakirja',
    engNimi: 'Promissory note',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 70,
    maara: 1,
    tilastoJarjestys: 32,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.VEROHALLINTO_REKISTEROINTI,
    nimi: 'Verohallinnon rekisteri-ilmoitus',
    engNimi: 'Tax administration registration notice',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 45,
    maara: 1,
    tilastoJarjestys: 30,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.YRITYKSEN_PERUSTAMINEN,
    nimi: 'Yrityksen perustaminen',
    engNimi: 'Establishing a company',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 200,
    maara: 1,
    tilastoJarjestys: 23,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.VARAINSIIRTOVEROILMOITUS,
    nimi: 'Varainsiirtoveroilmoitus',
    engNimi: 'Transfer tax filing',
    kategoria: TuoteKategoria.KIRJANPITO_KAPPALEHINTA,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_KAPPALEHINTA,
    hinta: 70,
    maara: 1,
    tilastoJarjestys: 33,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.KIRJANPITO_LISATYO_TUNTITYO,
    nimi: 'Kirjanpidon lisätyö (tuntityö)',
    engNimi: 'Additional bookkeeping work (hourly)',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 70,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.MYOHASSA_TAI_OHJEIDEN_VASTAISESTI_TOIMITETTU_AINEISTO,
    nimi: 'Myöhässä tai ohjeiden vastaisesti toimitetun aineiston kirjaaminen',
    engNimi: 'Bookkeeping of late or incorrectly delivered material',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 71,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.PROJEKTISEURANTA_KIRJANPIDOSSA,
    nimi: 'Projektiseuranta kirjanpidossa',
    engNimi: 'Project tracking in bookkeeping',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 72,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.SIJOITUSTOIMINTA_TUNTITYO,
    nimi: 'Sijoitustoimintaan liittyvät kirjanpitotyöt',
    engNimi: 'Investment bookkeeping work',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 16,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.KIRJANPITO_TAKAUTUVATYO,
    nimi: 'Takautuva kirjanpitotyö',
    engNimi: 'Retroactive bookkeeping work',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 11,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.TAUOLLA_OLEVAN_ASIAKKAAN_KIRJANPITOTYO,
    nimi: 'Tauolla olevan asiakkaan kirjanpitotyö',
    engNimi: 'Bookkeeping work for customer on break',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 73,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.TILINPAATOS_JA_VEROILMOITUS_KASVUPAKETTI,
    nimi: 'Tilinpäätös ja veroilmoitus (Kasvupaketti)',
    engNimi: 'Financial statement and tax return (Growth package)',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    maara: 1,
    tilastoJarjestys: 76,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
    muuJatkuvaVeloitus: true,
  },
  {
    avain: LaskutettavatPalvelut.TILINTARKASTUS_TYO,
    nimi: 'Tilintarkastukseen liittyvät työt',
    engNimi: 'Audit-related work',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 15,
    tilastoKategoria: TilastoKategoria.JATKUVALUONTEINEN_KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.VALITILINPAATOS,
    nimi: 'Välitilinpäätös',
    engNimi: 'Interim financial statement',
    kategoria: TuoteKategoria.KIRJANPITO_TUNTITYO,
    engKategoria: TuoteKategoriaEng.KIRJANPITO_TUNTITYO,
    hinta: 90,
    maara: 1,
    tilastoJarjestys: 27,
    tilastoKategoria: TilastoKategoria.KERTALASKUTUS,
  },
  {
    avain: LaskutettavatPalvelut.JATKUVA_KUUKAUSILASKUTUS,
    nimi: 'Palvelumaksu',
    engNimi: 'Service fee',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 1,
    tilastoKategoria: TilastoKategoria.KUUKAUSITTAINEN_PALVELUMAKSU,
  },
  {
    avain: LaskutettavatPalvelut.JATKUVA_KUUKAUSILASKUTUS_KORJAUS,
    nimi: 'Palvelumaksu (korjaukset)',
    engNimi: 'Service fee (corrections)',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 2,
    tilastoKategoria: TilastoKategoria.KUUKAUSITTAINEN_PALVELUMAKSU,
  },
  {
    avain: LaskutettavatPalvelut.MAKSUT,
    nimi: 'Maksut',
    engNimi: 'Payments',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 60,
    tilastoKategoria: TilastoKategoria.OHJELMISTO,
  },
  {
    avain: LaskutettavatPalvelut.MAKSUT_KORJAUS,
    nimi: 'Maksut (korjaukset)',
    engNimi: 'Payments (corrections)',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 61,
    tilastoKategoria: TilastoKategoria.OHJELMISTO,
  },
  {
    avain: LaskutettavatPalvelut.SAHKOISTEN_LASKUJEN_VASTAANOTTO,
    nimi: 'Sähköisten laskujen vastaanotto',
    engNimi: 'Electronic invoice receiving service',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    hinta: 5,
    maara: 1,
    tilastoJarjestys: 62,
    tilastoKategoria: TilastoKategoria.OHJELMISTO,
  },
  {
    avain: LaskutettavatPalvelut.SAHKOISTEN_LASKUJEN_VASTAANOTTO_KORJAUS,
    nimi: 'Sähköisten laskujen vastaanotto (korjaukset)',
    engNimi: 'Electronic invoice receiving service (corrections)',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    hinta: 5,
    maara: 1,
    tilastoJarjestys: 63,
    tilastoKategoria: TilastoKategoria.OHJELMISTO,
  },
  {
    avain: LaskutettavatPalvelut.KAMPANJAHYVITYS,
    nimi: 'Kampanjahyvitys',
    engNimi: 'Campaign discount',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 3,
    tilastoKategoria: TilastoKategoria.KUUKAUSITTAINEN_PALVELUMAKSU,
    muuJatkuvaVeloitus: true,
  },
  {
    avain: LaskutettavatPalvelut.HINNANKOROTUS_WINBACK,
    nimi: 'Hinnankorotus win-back',
    engNimi: 'Price increase win-back',
    kategoria: TuoteKategoria.MUUT_PALVELUT,
    engKategoria: TuoteKategoriaEng.MUUT_PALVELUT,
    maara: 1,
    tilastoJarjestys: 4,
    tilastoKategoria: TilastoKategoria.KUUKAUSITTAINEN_PALVELUMAKSU,
  },
  {
    avain: LaskutettavatPalvelut.PALKKALASKELMA_TYEL,
    nimi: 'Palkkalaskelma Tyel',
    engNimi: 'Payroll statement TyEL',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 24,
    maara: 1,
    tilastoJarjestys: 40,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKKALASKELMA_YEL,
    nimi: 'Palkkalaskelma YEL',
    engNimi: 'Payroll statement YEL',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 20,
    maara: 1,
    tilastoJarjestys: 41,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKKAPALVELU_LEMONTREE,
    nimi: 'Palkkapalvelu Lemon Tree',
    engNimi: 'Payroll service Lemon Tree',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    maara: 1,
    tilastoJarjestys: 47,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKKATODISTUS,
    nimi: 'Palkkatodistus',
    engNimi: 'Salary certificate',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 9,
    maara: 1,
    tilastoJarjestys: 44,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKAT_TUNTITYO,
    nimi: 'Palkat tuntityö',
    engNimi: 'Payroll hourly work',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    maara: 1,
    tilastoJarjestys: 42,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKAT_VIIVASTYS_MAKSU,
    nimi: 'Palkat viivästysmaksu',
    engNimi: 'Payroll late fee',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 45,
    maara: 1,
    tilastoJarjestys: 45,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKAT_REVENUESHARE,
    nimi: 'Revenue share',
    engNimi: 'Revenue share',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    maara: 1,
    tilastoJarjestys: 48,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.ULOSOTTO,
    nimi: 'Ulosotto',
    engNimi: 'Enforcement',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 9,
    maara: 1,
    tilastoJarjestys: 43,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
  {
    avain: LaskutettavatPalvelut.PALKAT_UUSI_TYONTEKIJA,
    nimi: 'Uuden työntekijän lisääminen',
    engNimi: 'Adding a new employee',
    kategoria: TuoteKategoria.PALKAT,
    engKategoria: TuoteKategoriaEng.PALKAT,
    hinta: 20,
    maara: 1,
    tilastoJarjestys: 46,
    tilastoKategoria: TilastoKategoria.PALKKAPALVELUT,
  },
]

// Kaikki muut, jotka ei virallisia tuotenimikkeitä
export const MUU_LASKUTUS = 'Muu laskutus'
